import React, { ReactNode, useState } from "react";
import { GrayBorderBox } from "./boxes";
import { GrayButton } from "./buttons";
import {
  LeftLittleTitle,
  LeftGrayContent,
  LeftBlackContent,
} from "./texts";
import { 
  PostInstallationMedia,
  SpecificBooking,
  SolarPanel,
  Inverter,
} from "../types/responseTypes";
import {
  AdditionalWork,
} from "../types/provisionalTypes";

interface InstallationImagesProps {
  provisionalMedia: PostInstallationMedia;
  fetchedMedia?: PostInstallationMedia | null;
}

export const InstallationImages: React.FC<InstallationImagesProps> = ({
  provisionalMedia,
  fetchedMedia,
}) => {
  return (
    <div className="flex flex-wrap justify-start mt-4 mb-4">
      {provisionalMedia.media.map((item, index) => {
        const fetchedUrl = fetchedMedia && Array.isArray(fetchedMedia) && fetchedMedia[index]?.url ? fetchedMedia[index].url : provisionalMedia.media[index].url;
        return (
          <GrayBorderBox
            key={item.mediaId || "IIC2154"}
            w="300px"
            h="183.89px"
            m="4px"
            p="0px"
          >
            {/* Image that fits inside the padding */}
            <div className="w-full h-full">
              <img
                src={fetchedUrl}
                alt={item.type || "provisional"}
                className="w-full h-full object-cover rounded-[20px]"
              />
            </div>
          </GrayBorderBox>
        );
      })}
    </div>
  );
};

interface SolarPanelImagesProps {
  solarPanel: SolarPanel | null;
  specificBooking: SpecificBooking | null;
}

export const SolarPanelImage: React.FC<SolarPanelImagesProps> = ({ solarPanel, specificBooking }) => {
  if (!solarPanel || !specificBooking) {
    return null;
  }

  return (
    <div className="flex flex-col justify-center w-[616px] h-auto m-4">
      <div className="relative w-full h-[400px] bg-[#F3F4F6] rounded-[36px] p-8 overflow-hidden m-1">
        <div className="absolute top-4 left-8 z-10">
          <LeftBlackContent>{specificBooking.amountSolarPanels}</LeftBlackContent>
          <LeftBlackContent fontSize="20px">{solarPanel.brand}</LeftBlackContent>
          <LeftBlackContent>{solarPanel.power} W</LeftBlackContent>
        </div>
        <img
          src={solarPanel.imageUrl}
          alt={solarPanel.model || "solar panel"}
          className="w-full h-full object-contain"
        />
      </div>
      <LeftLittleTitle>Paneles solares</LeftLittleTitle>
      <LeftGrayContent>
        Los paneles solares capturan la luz del sol y la convierten
        en electricidad, generando corriente continua (CC).
      </LeftGrayContent>
      <div className="flex justify-start gap-2 mt-2">
        <GrayButton
          label="Ficha técnica"
          h="44px"
          icon="paper"
          onClick={() => window.open(solarPanel.datasheetUrl, "_blank")}
        />
        {/* <GrayButton
          label="Detalles de garantía"
          h="44px"
          icon="paper"
          onClick={() => window.open(solarPanel.datasheetUrl, "_blank")}
        /> */}
      </div>
    </div>
  );
};

interface InverterImagesProps {
  inverter: Inverter | null;
  specificBooking: SpecificBooking | null;
}

export const InverterImage: React.FC<InverterImagesProps> = ({ inverter, specificBooking }) => {
  if (!inverter || !specificBooking) {
    return null;
  }

  return (
    <div className="flex flex-col justify-center w-[616px] h-auto m-4">
      <div className="relative w-full h-[400px] bg-[#F3F4F6] rounded-[36px] p-8 overflow-hidden m-1">
        <div className="absolute top-4 left-8 z-10">
          <LeftBlackContent>1</LeftBlackContent>
          <LeftBlackContent fontSize="20px">{inverter.brand}</LeftBlackContent>
          <LeftBlackContent>{inverter.power} W</LeftBlackContent>
        </div>
        <img
          src={inverter.imageUrl}
          alt={inverter.model || "inverter"}
          className="w-full h-full object-contain"
        />
      </div>
      <LeftLittleTitle>Inversor</LeftLittleTitle>
      <LeftGrayContent>
        El inversor transforma la corriente continua (CC) de los paneles
        en corriente alterna (CA) que luego usan tus electrodomésticos.
        También sincroniza la energía con la red eléctrica y protege el sistema.
      </LeftGrayContent>
      <div className="flex justify-start gap-2 mt-2">
        <GrayButton
          label="Ficha técnica"
          h="44px"
          icon="paper"
          onClick={() => window.open(inverter.datasheetUrl, "_blank")}
        />
        {/* <GrayButton
          label="Detalles de garantía"
          h="44px"
          icon="paper"
          onClick={() => window.open(inverter.datasheetUrl, "_blank")}
        /> */}
      </div>
    </div>
  );
};

interface AdditionalImageProps {
  additonalWork: AdditionalWork | null;
}

export const AdditionalImage: React.FC<AdditionalImageProps> = ({ additonalWork }) => {
  if (!additonalWork) {
    return null;
  }

  return (
    <div className="flex flex-col justify-center w-[616px] h-auto m-4">
      <div className="relative w-full h-[400px] bg-[#F3F4F6] rounded-[36px] overflow-hidden m-1">
        <img
          src={additonalWork.imageUrl}
          alt={"Additional work"}
          className="w-full h-full object-cover rounded-[36px]"
        />
      </div>
      <LeftLittleTitle>{additonalWork.title}</LeftLittleTitle>
      <LeftGrayContent>
        {additonalWork.description}
      </LeftGrayContent>
    </div>
  );
};